export interface Question {
  path: string;
  question: string;
  answer: string;
  link?: string;
  linkText?: string;
}

export interface Topic {
  topic: string;
  questions: Question[];
}

export const questions: Topic[] = [
  {
    topic: 'General',
    questions: [
      {
        path: '/questions/when-rsvp',
        question: 'When is the RSVP deadline?',
        answer: 'April 1, 2018',
      },
      {
        path: '/questions/registry',
        question: 'Where are you registered?',
        answer: "We've registered at Traveler's Joy (a honeymoon registry) and West Elm.",
        link: '/registry',
        linkText: 'Find out more on our registry page.',
      },
      {
        path: '/questions/traditional',
        question: 'Is there anything "traditional" that you don’t plan on doing?',
        answer: "We're not doing a bouquet toss or a garter toss.",
      },
    ],
  },
  {
    topic: 'Travel & Accommodations',
    questions: [
      {
        path: '/questions/travel-recs',
        question: 'Any travel recommendations?',
        answer:
          "Hawaiian Airlines has the most direct flights. There's only one airport on Oahu \
          but there are lots of islands in Hawaii, so make sure you're flying into Honolulu International Airport \
          on the island of Oahu.",
      },
      {
        path: '/questions/accommodations',
        question: 'Where should we stay?',
        answer:
          'We recommend staying close to all the wedding events on the Northshore, \
          but if nightlife is your thing, then you might prefert to stay in Waikiki/Honolulu.',
        link: '/accommodations',
        linkText: 'Find out more on our accommodations page.',
      },
      {
        path: '/questions/location',
        question: 'What is there to do on the island?',
        answer: "Hike, Swim, Eat, Drink, Explore. It's all here, so get out there and enjoy it!",
        link: '/location',
        linkText: 'Find out more on our location page.',
      },
    ],
  },
  {
    topic: 'Guests',
    questions: [
      {
        path: '/questions/children-welcome',
        question: 'Are children welcome?',
        answer: 'Sorry, our wedding will be adults only.',
      },
      {
        path: '/questions/guests',
        question: 'My invitation says "and guest". Do I have to bring a guest?',
        answer:
          'No, of course not. We just wanted to give you the option. Feel free to come by yourself and make friends!',
      },
      {
        path: '/questions/attire',
        question: 'What should I wear?',
        answer:
          'Summertime cocktail attire. No aloha shirts, shorts, or slippers (flip-flops to you main-landers). \
          Save those for the next day!',
      },
    ],
  },
  {
    topic: 'Food & Drink',
    questions: [
      {
        path: '/questions/food',
        question: 'What kind of food will be served?',
        answer:
          "We'll have passed pupus (appetizers) for the cocktail hour, a 3-course dinner with delicious,\
          locally sourced ingredients, and dessert. Come hungry!",
      },
      {
        path: '/questions/dietary',
        question: 'What if I have a dietary restriction?',
        answer: 'Let us know when you RSVP and we will do our best to accommodate you!',
        link: '/rsvp',
        linkText: 'RSVP',
      },
      {
        path: '/questions/drinks',
        question: 'Will we need to pay for drinks?',
        answer: 'Matt says you can throw in on his Costco membership. Just kidding, we got you.',
      },
    ],
  },
  {
    topic: 'Venue',
    questions: [
      {
        path: '/questions/venue',
        question: 'What is the venue like?',
        answer:
          "Dillingham Ranch is in between the mountains and the ocean. Don't be surprised if you find a horse \
          or a peacock roaming around. The ceremony, cocktail hour, dinner, and dancing will all be outdoors.",
      },
      {
        path: '/questions/transportation',
        question: 'How do I get to the venue?',
        answer:
          "Head up to the Northshore, leaving from either Waikiki \
          or Turtle Bay. The address for Dillingham Ranch is 68-540 Farrington Hwy, Waialua, HI 96791.\
          Just look for the sign for Bri & Matt's wedding!",
      },
      {
        path: '/questions/parking',
        question: 'Is parking available?',
        answer: 'Yes, under the monkeypod trees!',
      },
      {
        path: '/questions/arrival-time',
        question: 'What time should I arrive?',
        answer: 'The ceremony kicks off at 4:30 pm, so plan to be there by 4:00 pm to find your seat and settle in.',
      },
      {
        path: '/questions/departure-time',
        question: 'When will the reception end?',
        answer: "We'll be officially husband & wife (what?!) and the party will officially end at 10:00pm.",
      },
    ],
  },
  {
    topic: 'Other',
    questions: [
      {
        path: '/questions/unanswered',
        question: "I have a question that wasn't answered here?",
        answer: 'Send it our way!',
        link: '/contact',
        linkText: 'Contact us.',
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/data/questions.ts